function moveReviews(){
  if ( $(window).width() > 959 ) {
    $('.pwr-category-snippets').each(function(){
      var target = $(this).parent().find('.info .title')
      $(this).insertAfter(target)
    })
  }else {
    $('.pwr-category-snippets').each(function(){
      var target = $(this).parent()
      $(this).insertAfter(target)
    })
  }
}

setTimeout(function(){
  $('.cart-loader').removeClass('cart-loader')
}, 3000)

$(document).ready(function(){


  $(window).on('load',function(){
    $('<p class="new_prw_terms_msg">By submitting, you represent that you have read and agree to our <a href="/pages/terms-of-use">Terms</a> and our <a href="/pages/privacy-policy">Privacy Policy</a></p>').insertAfter('#pr-write .pr-subscript');

    $('.new_prw_terms_msg:eq(1)').hide()

    if ( !$('.sort_by_text').length ){
    $('<div class="sort_by_text">Sort by: </div>').insertBefore('select#pr-rd-sort-by');
    }

    setTimeout(function(){
      //$('label[for="pr-media_videourl"]').text('Upload a Video');
      //$('label[for="pr-media_image"]').text('Upload an Image');
      //$('.form-group.pr-name-form-group .pr-control-label span:first-of-type').text('Name');
    },1000)

    $('#cart_form input.action_button').removeClass('promo');
    $('.cart-loader').removeClass('cart-loader')
    $('body.cart').css('opacity',1);
    $('.faqAccordion > dt > button').addClass('loaded');

    // powr reviews
    $('body').on('click','.pr-snippet-stars > div',function(){

          $('.pwr-tabs .pwr-tab-reviews').click()
          $('html, body').animate({
            scrollTop: $('.pwr-tabs .pwr-tab-reviews').offset().top - 100
          }, 500);

    })

    moveReviews()

    $('.pr-reco-to-friend-message').text(' of reviewers recommend this product');
    $('.pr-review-snapshot-recomend').appendTo('.pr-review-snapshot-block.pr-review-snapshot-block-snippet');
    $('.pr-review-snapshot-recomend .pr-reco-to-friend-message').appendTo('.pr-review-snapshot-recomend .pr-reco.pr-reco-green');

    pdpSliderHeight();
  })

  var reports_link = $('body.product .faqAccordion button.reports a').attr('href');
  $('body.product .faqAccordion button.reports').wrap('<a target="_blank" href='+reports_link+'></a>');


  $('body.product div.t .info h2').click(function(){
    $(this).parent('.info').toggleClass('exp');
  });

  $('body div.shopify-product-reviews-container').click(function(){
    reviews_go();
  });

  $('a[href="#newsletter"]').click(function(e){
    e.preventDefault();
    $('[data-remodal-id=newsletter]').remodal().open();
  })

  // $('.faqAccordion.product button#first_btn').click();


   $('a#top_subscribe').click(function(){
     swellAPI.showPopupByType("EmailCapturePopup");
   });

  $('a.t.cart_content__continue-shopping').click(function(){
    $('.cart_container').removeClass('active_link');
  });

  $('ul.mobile-mega-menu>div:first-child>li.mobile-mega-menu_block.sublink a.parent-link--false').addClass('active').hide();
  $('ul.mobile-mega-menu>div:first-child>li.mobile-mega-menu_block.sublink>ul').css('padding-left','0').show();
  $('ul.mobile-mega-menu>div:first-child>li.mobile-mega-menu_block.sublink>ul>li').css('padding-left','0');

  /* Product Grid item - select option change */
  $(document).on('change', '.product-wrap .thumbnail-overlay .select select', function(){
    var data_sale = $(this).find('option:selected').data('sale');
    var v_price = $(this).find('option:selected').text().split(' - ')[1];
    if (data_sale) {
      var sale_price = data_sale.split('money>')[1].split('</span>')[0];
      $(this).parents('.product-wrap').find('.product-details .was_price span .money').text(sale_price);
      //console.log(sale_price);
    }
    $(this).parents('.product-wrap').find('.org_price .money').text(v_price);
  });

  /* New mobile menu */
  $(document).on('click', '#mobile-fullscreen-menu .mini_cart', function() {
    window.location.href = "/cart";
  });
  $(document).on('click', '.menu-bottom-section .icon-search', function() {
    $(".extend-search-form-wrapper input[type='text']").focus();
  });
  $('.extend-search-form form input[type="text"]').off('click').on('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
  });

  /* Image Finder */
  $(document).on('click', '.image-finder-wrapper .product-handle-wrapper .button', function() {
    var productHandle = $('.image-finder-wrapper .product-handle-wrapper .product-handle').val();
    var imageIdInner = '';
    $.ajax({
      url: '/products/' + productHandle + '.json',
      type: 'get',
      success: function(response) {
        console.log(response);
        imageIdInner += '<h5>Product Title: ' + response.product.title + '</h5><div class="product-images">';
        for (var i in response.product.images) {
          imageIdInner += '<div class="product-image"><span>' + response.product.images[i].id + '</span>' + '<img src="' + response.product.images[i].src + '"></div>';
        }
        imageIdInner += '</div>';
        $('.image-id-wrapper').html(imageIdInner);
      },
      error: function(error) {
        imageIdInner += '<h5>Product is not found.</h5>';
        $('.image-id-wrapper').html(imageIdInner);
      }
    });
  });

  /* Collection Tabs */
  $(document).on('click', '.tablink', function() {
    $('.tabcontent').each(function() {
      $(this).removeClass('active');
    });
    $('.tablink').each(function() {
      $(this).removeClass('active');
    });
    $(this).addClass('active');
    var index = $(this).data('index');
    $(this).parents('.collection-tabs-inner').find('.tabcontent[data-index=' + index + ']').addClass('active');
    if (window.innerWidth <= 798) {
      $([document.documentElement, document.body]).animate({
        scrollTop: $(".collection-tabs-inner .contents").offset().top
      }, 1000);
    }
  });

  /* Collection Reviews */
  $('.collection-reviews-inner .reviews').flickity({wrapAround: true});

  /* Wonder - Gift guide */
  $(document).on('click', '.guide-tab-item', function() {
    var dataIndex = $(this).data('index');
    $([document.documentElement, document.body]).animate({
        scrollTop: $(".guide-content-item[data-index=" + dataIndex + "] .guide-content-links").offset().top - 100
      }, 500);
  });

  /* New Nav Menu */
  $('.header-main-section .main-navigation-menu .dropdown_link').each(function(index) {
    var $this = $(this),
        leftPos = $this.offset().left,
        navWrap = $(this).parents('.main_nav'),
        dropRel = $this.data('dropdown-rel'),
        dropContent = navWrap.find('[data-dropdown="' + dropRel + '"]'),
        windowWidth = $(window).width();

    if ( leftPos + 320 > windowWidth ) {
      var offsetLeft = leftPos + 320 - windowWidth;
      leftPos = leftPos - offsetLeft;
    }

    dropContent.find('.dropdown').css('left', leftPos + 'px');
  });

  $(window).resize(function() {
    $('.header-main-section .main-navigation-menu .dropdown_link').each(function(index) {
      var $this = $(this),
          leftPos = $this.offset().left,
          navWrap = $(this).parents('.main_nav'),
          dropRel = $this.data('dropdown-rel'),
          dropContent = navWrap.find('[data-dropdown="' + dropRel + '"]'),
          windowWidth = $(window).width();;

      if ( leftPos + 320 > windowWidth ) {
        var offsetLeft = leftPos + 320 - windowWidth;
        leftPos = leftPos - offsetLeft;
      }

      dropContent.find('.dropdown').css('left', leftPos + 'px');
    });
    pdpSliderHeight();
  });

  /* Aroma Notes */
  $('.carousel-slide-section').flickity({wrapAround: true});
  $(document).on('click', '.aroma-login', function() {
    var d = new Date();
    d.setTime(d.getTime() + (24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = "rewardscookie" + "=" + "rewardscookie" + ";" + expires + ";path=/";
    window.location.href="/account/login";
  });
  $(document).on('click', '.aroma-register', function() {
    var d = new Date();
    d.setTime(d.getTime() + (24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = "rewardscookie" + "=" + "rewardscookie" + ";" + expires + ";path=/";
    window.location.href="/account/register";
  });
  
  $('.entry-members-section .action_button').on('click', function(e) {
    e.preventDefault();

    var a = $(this).attr('href'),
        b = $(this).parents('.shopify-section').find(a);
    $('html,body').animate({scrollTop: b.offset().top - 50},'slow');
  });

  /* Pledge Page */
  $('.single-title-heading .anchor-btn').on('click', function(e) {
    var $this = $(this),
        anchorEle = $this.data('id');

    $('html, body').animate({
      scrollTop: $('#' + anchorEle).offset().top
    }, 500);
  });

  $(document).off('click', '.pledge-heading .description-toggle-btn').on('click', '.pledge-heading .description-toggle-btn', function(e) {
    e.preventDefault();

    $(this).toggleClass('active');
    $(this).prev('.toggle-txt').slideToggle(250);
  });

  $('.single-pledge-element .mobile-toggle-btn').on('click', function(e) {
    e.preventDefault();

    $(this).addClass('toggled');
    $(this).next('.toggle-content').slideDown(250);
    $(this).parents('.single-pledge-element').addClass('show-bg');
    $(this).parents('.pledge-elements-body').addClass('disable-margin');

    $('.single-pledge-element.show-bg').css('margin-top', '');
    $('.single-pledge-element.show-bg').each(function(index) {
      if ( ! $(this).prev().hasClass('show-bg') ) $(this).css('margin-top', '0px');
    });
  });

  $('.single-pledge-element .mobile-content-close').on('click', function(e) {
    e.preventDefault();

    $(this).parent('.toggle-content').slideUp(250);
    $(this).parent('.toggle-content').prev('.mobile-toggle-btn').removeClass('toggled');
    $(this).parents('.single-pledge-element').removeClass('show-bg');
    $(this).parents('.pledge-elements-body').removeClass('disable-margin');

    $('.single-pledge-element.show-bg').css('margin-top', '');
    $('.single-pledge-element.show-bg').each(function(index) {
      if ( ! $(this).prev().hasClass('show-bg') ) $(this).css('margin-top', '0px');
    });
  });

  /* Dynamic Nav position - Countdown Timer issue */
  document.querySelector('body').addEventListener('DOMSubtreeModified', function() {
    if ($('#epb_background').length) {
      var epb_height = $('#epb_background').css('height');
      $('#epb_container').css('height', epb_height);
      $('.mobile_nav-fixed--true').css('margin-top', epb_height);
    }
  });

  /* PDP - Slider height on mobile/tablet */
  function pdpSliderHeight() {
    if ($('body').hasClass('product')) {
      var min_height = 0;
      $('.product_section.dev .nine.columns .gallery-wrap').each(function() {
        if ($(this).height() > min_height) {
          min_height = $(this).height();
        }
      });
      $('.product_section.dev .nine.columns').css('min-height', min_height);
    }
  }
  pdpSliderHeight();
});

$(document).on("swell:setup", function() {

    $('a#top_subscribe').css('visibility','visible');


  var vipTiers = swellAPI.getVipTiers();

  var isTierReached = false;
  var pointDifference = 0;

  var customerDetails = swellAPI.getCustomerDetails();

  vipTiers.forEach(function(tier){
    var pointsEarned = customerDetails.vipTierStats ? customerDetails.vipTierStats.pointsEarned : 0;
    if(pointsEarned >= tier.swellrequiredPointsEarned) {
      isTierReached = true;
    }
    pointDifference = tier.swellrequiredPointsEarned - pointsEarned;
  });
    // Desktop
  $(".desktop-rewards #swellRemainingPoints").html(pointDifference + " Notes away ");
    // Mobile
    $(".mobile-rewards #swellRemainingPoints").html(pointDifference + " Notes away ");

  if(isTierReached) {
        // Desktop
    $(".desktop-rewards .membership-area").hide();
    $(".desktop-rewards .lavendar-plan").hide();
    $(".desktop-rewards .rose-plan").show();
    $('.desktop-rewards .point_area .point_text').addClass("rose_text");
        // Mobile
    $(".mobile-rewards .membership-area").hide();
    $(".mobile-rewards .lavendar-plan").hide();
    $(".mobile-rewards .rose-plan").show();
    $('.mobile-rewards .point_area .point_text').addClass("rose_text");
  } else {
        // Desktop
    $(".desktop-rewards .lavendar-plan").show();
    $(".desktop-rewards .rose-plan").hide();

        // Mobile
    $(".mobile-rewards .lavendar-plan").show();
    $(".mobile-rewards .rose-plan").hide();
  }

  var toAppend = customerDetails.email && customerDetails.email != "" ? referral_registered : referral_new;
    // Desktop
  $(".desktop-rewards .referral-container").append(toAppend);
    // Mobile
    $(".mobile-rewards .referral-container").append(toAppend);

  var FADE_MS = 500;
    var clipboard = new ClipboardJS('#swell-copy-clipboard-btn');
  var referral_registered_stated;

    // Desktop
  $(document).on("click", ".desktop-rewards .swell-copy-link", function(e) {
    e.preventDefault();
    $(referral_copy).hide().appendTo("body").fadeIn(FADE_MS);
    swellAPI.refreshEmbeds();
  });
    // Mobile
  $(document).on("click", ".mobile-rewards .swell-copy-link", function(e) {
    e.preventDefault();
    $(referral_copy).hide().appendTo("body").fadeIn(FADE_MS);
    swellAPI.refreshEmbeds();
  });

    // Desktop
  $(document).on("click", ".desktop-rewards .back-link", function(e) {
    e.preventDefault();
    if($(".desktop-rewards .referral-copy").length > 0) {
      $(".desktop-rewards .referral-copy").fadeOut(FADE_MS, function() { $(this).remove(); });
    } else {
      $(".desktop-rewards .thanks-container").fadeOut(FADE_MS, function() { $(this).remove(); });
      setTimeout(function() {
        $(referral_registered_stated).hide().appendTo(".desktop-rewards .referral-container").fadeIn(FADE_MS);
        swellAPI.refreshEmbeds();
      }, FADE_MS);
    }
  });
    // Mobile
  $(document).on("click", ".mobile-rewards .back-link", function(e) {
    e.preventDefault();
    if($(".mobile-rewards .referral-copy").length > 0) {
      $(".mobile-rewards .referral-copy").fadeOut(FADE_MS, function() { $(this).remove(); });
    } else {
      $(".mobile-rewards .thanks-container").fadeOut(FADE_MS, function() { $(this).remove(); });
      setTimeout(function() {
        $(referral_registered_stated).hide().appendTo(".mobile-rewards .referral-container").fadeIn(FADE_MS);
        swellAPI.refreshEmbeds();
      }, FADE_MS);
    }
  });

    // Desktop
  $(document).on("submit", ".desktop-rewards #refer-form", function(e) {
    e.preventDefault();
    referral_registered_stated = $(".desktop-rewards .referral-registered");
    var $emails = $(".desktop-rewards #refer-form #referrer-email-list");
    var emails = $emails.val().split(",");

    var successCB = function() {
      $(".desktop-rewards .referral-registered").fadeOut(FADE_MS, function() {
        $emails.val("").removeClass("error");
        $(this).remove();
      });
      setTimeout(function(){
        $(referral_thanks).hide().appendTo(".desktop-rewards .referral-container").fadeIn(FADE_MS);
      }, FADE_MS);
    };

    var errorCB = function() {
      $emails.addClass("error");
    };
    swellAPI.sendReferralEmails(emails, successCB, errorCB);
  });
    // Mobile
  $(document).on("submit", ".mobile-rewards #refer-form", function(e) {
    e.preventDefault();
    referral_registered_stated = $(".mobile-rewards .referral-registered");
    var $emails = $(".mobile-rewards #refer-form #referrer-email-list");
    var emails = $emails.val().split(",");

    var successCB = function() {
      $(".mobile-rewards .referral-registered").fadeOut(FADE_MS, function() {
        $emails.val("").removeClass("error");
        $(this).remove();
      });
      setTimeout(function(){
        $(referral_thanks).hide().appendTo(".mobile-rewards .referral-container").fadeIn(FADE_MS);
      }, FADE_MS);
    };

    var errorCB = function() {
      $emails.addClass("error");
    };
    swellAPI.sendReferralEmails(emails, successCB, errorCB);
  });

    // Desktop
  $(document).on("submit", ".desktop-rewards #referral-register", function(e) {
    e.preventDefault();
    var $email = $(".desktop-rewards #referral-register #referrer-email");
    var email = $email.val();

    var success = function() {
      $(".desktop-rewards .register").fadeOut(FADE_MS, function() { $(this).remove() });
      setTimeout(function(){
        $(referral_registered).prepend(referral_registered_new).hide().appendTo(".desktop-rewards .referral-container").fadeIn(FADE_MS);
        swellAPI.refreshEmbeds();
      }, FADE_MS);
    };
    var error = function() {
      $email.addClass("error");
    };
    swellAPI.identifyReferrer(email, success, error);
  });
    //Mobile
  $(document).on("submit", ".mobile-rewards #referral-register", function(e) {
    e.preventDefault();
    var $email = $(".mobile-rewards #referral-register #referrer-email");
    var email = $email.val();

    var success = function() {
      $(".mobile-rewards .register").fadeOut(FADE_MS, function() { $(this).remove() });
      setTimeout(function(){
        $(referral_registered).prepend(referral_registered_new).hide().appendTo(".mobile-rewards .referral-container").fadeIn(FADE_MS);
        swellAPI.refreshEmbeds();
      }, FADE_MS);
    };
    var error = function() {
      $email.addClass("error");
    };
    swellAPI.identifyReferrer(email, success, error);
  });

});

function reviews_go() {
  if ( $("dt#product-content-reviews > button").attr("aria-expanded") == "false"){
    $("dt#product-content-reviews > button").click();
  }
  setTimeout(function(){
    scrollToAnchor("product-reviews");
  },300)
}

function scrollToAnchor(aid){
    var aTag = $("a[name='"+ aid +"']");
    $('html,body').animate({scrollTop: aTag.offset().top},'slow');
}


//reviews in product page elements mod

$(document).ready(function(){

  


});
